/* eslint-disable @typescript-eslint/no-empty-function */
import { call, put } from 'redux-saga/effects';
import { iActionListShifts } from '~/domain/interfaces/redux/teleShifts/list';

import { ListShifts } from '~/domain/usecases/teleShifts/remote';

import {
  listShiftsFailed,
  listShiftsSuccess,
} from '~/data/store/reducer/teleShifts/actions/list';

import { makeRemoteListShifts } from '~/main/factories/usecases/teleShifts';

export function* onListShifts(action: iActionListShifts) {
  const remoteDeleteShifts = makeRemoteListShifts();

  try {
    const response: ListShifts.Model = yield call(
      remoteDeleteShifts.list,
      action.payload,
    );

    yield put(listShiftsSuccess(response));
  } catch (e) {
    yield put(listShiftsFailed());
  }
}

export function onListShiftsSuccess() {}

export function onListShiftsFailed() {}
